<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m38.156 62.244-.416.413.021.021.416-.413-.021-.021Z" fill="#fff" />
      <path
        d="M90.617 61.913 61.976 33.478a2.464 2.464 0 0 0-3.464 0l-9.31 9.243-9.31-9.243a2.468 2.468 0 0 0-3.467 0L7.787 61.913a2.416 2.416 0 0 0 0 3.44l11.886 11.802a2.467 2.467 0 0 0 3.467 0l9.31-9.243 9.31 9.243a2.464 2.464 0 0 0 3.464 0l15.019-14.913 15.021 14.913a2.463 2.463 0 0 0 3.464 0l11.89-11.803a2.42 2.42 0 0 0 0-3.439Zm-69.21 8.362-6.693-6.644L38.158 40.36l6.713 6.662-6.691 6.643-.022-.021-16.752 16.632Zm55.588 0L60.242 53.643 43.49 70.275l-6.688-6.644.961-.955-.021-.02.416-.414.022.02L60.243 40.36l23.443 23.272-6.691 6.644Z"
        fill="currentColor"
      />
      <path d="m38.156 62.244-.416.413.021.021.416-.413-.021-.021Z" fill="#282425" />
      <path
        d="m49.206 16.58-9.383 9.316 9.383 9.316 9.384-9.316-9.384-9.316Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
